
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 4h2v16.563L20.563 10H11V8h11.563l3.719-3.719 1.438 1.438-3.719 3.719v11.563h-2v-9.563L11.438 22.001h16.563v2h-4v4h-2v-4h-14v-14h-4v-2h4v-4z"}})])
          )
        }
      }
    